/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { forwardRef, useRef } from 'react';

import PropTypes from 'prop-types';

import { ImageLoader } from '../../../ImageLoader';
import { ImageLoaderTypes } from '../../../ImageLoader/ImageLoaderTypes';
import { HighlightTexts } from '../HighlightTexts';
import { TextViewClasses } from './TextViewClasses';
import { TextViewProps } from './TextViewProps';

import './TextView.scss';

const TextView = forwardRef<HTMLDivElement, TextViewProps>((props, ref): JSX.Element => {
    const { text, type, iconUrl } = props;
    const imageContainerRef = useRef<HTMLDivElement>(null);
    const textViewTextRef = useRef<HTMLDivElement>(null);

    return (
        <div className={`text-view ${type || TextViewClasses.DEFAULT}`} ref={ref}>
            <div
                className={`text-view-text ${
                    type === TextViewClasses.SUBTITLE &&
                    (textViewTextRef.current?.scrollWidth || 0) >
                        (textViewTextRef.current?.offsetWidth || 0)
                        ? type
                        : ''
                }`}
                style={{
                    maxWidth: `calc(100% - ${imageContainerRef.current?.offsetWidth || 0}px)`,
                }}
                ref={textViewTextRef}
            >
                <HighlightTexts text={text} />
            </div>
            {iconUrl ? (
                <div className="text-view-icon-container" ref={imageContainerRef}>
                    <ImageLoader src={iconUrl} imageType={ImageLoaderTypes.TEXT_VIEW_ICON} />
                </div>
            ) : null}
        </div>
    );
});

TextView.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.string,
    iconUrl: PropTypes.string,
};

export default TextView;
